import React from "react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function FAQAccordionItem({ faq, isOpen, onToggle }) {
  return (
    <div className="bg-card border border-border rounded-[10px] overflow-hidden">
      <button
        className="w-full text-left px-6 py-5 flex items-center justify-between gap-4 hover:bg-muted/30 transition-colors"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span className="font-bold text-brand-navy text-sm sm:text-base">{faq.question}</span>
        <ChevronDown
          className={`w-5 h-5 text-muted-foreground shrink-0 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <div className="px-6 pb-5">
              <p className="text-sm text-muted-foreground leading-relaxed">{faq.answer}</p>
              {faq.sources && (
                <p className="mt-2 text-xs text-muted-foreground">
                  Source:{" "}
                  {faq.sources.map((s, i) => (
                    <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="text-brand-teal font-medium hover:underline">
                      {s.label}
                    </a>
                  ))}
                </p>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}